import { useEffect, useState } from "react";
import { DocumentSubType, type FormInt } from "@/briefpoint-client";
import { useObjectionApi } from "./useApi";

export function useDocumentFormInterrogatories(
  subType?: DocumentSubType,
): FormInt[] | null {
  const [formInterrogatories, setFormInterrogatories] = useState<
    FormInt[] | null
  >(null);
  const objectionApi = useObjectionApi();

  useEffect(() => {
    if (!formInterrogatories && subType === DocumentSubType.FormInterrogatories)
      objectionApi.objectionGetFormInts().then((formInts) => {
        setFormInterrogatories(formInts);
      });
  }, [objectionApi, subType, formInterrogatories]);

  return formInterrogatories;
}
